// Auto-generated by scripts/generate-registry.mjs from packages/modules/lamp_021/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const lamp_021: ModuleSchema = {
  "id": "lamp_021",
  "uniqueId": "B3D_L021A",
  "createdAt": "2026-10-12T14:10:33.274Z",
  "updatedAt": "2026-10-13T13:23:43.076Z",
  "label": "Floravia",
  "description": "Parametric lamp with a fluted base and a four-lobe spiral flower shade.",
  "category": "lighting",
  "tags": [
    "lamp-021"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Base Diameter",
      "min": 60,
      "max": 120,
      "default": 85,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseH",
      "label": "Base Height",
      "min": 40,
      "max": 120,
      "default": 70,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "numFlutes",
      "label": "Base Flutes Count",
      "min": 10,
      "max": 80,
      "default": 40,
      "step": 2,
      "unit": "",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "fluteDepth",
      "label": "Flute Depth",
      "min": 0.5,
      "max": 4,
      "default": 1.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "shadeH",
      "label": "Shade Height",
      "min": 120,
      "max": 300,
      "default": 215,
      "step": 5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeBotDia",
      "label": "Shade Bottom Diameter",
      "min": 90,
      "max": 180,
      "default": 137,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeBellyDia",
      "label": "Shade Belly Max Diameter",
      "min": 120,
      "max": 260,
      "default": 178,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeTopDia",
      "label": "Shade Top Opening Diameter",
      "min": 50,
      "max": 130,
      "default": 80,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "numRibs",
      "label": "Shade Ribs Count",
      "min": 20,
      "max": 120,
      "default": 80,
      "step": 4,
      "unit": "",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "waveAmp",
      "label": "Rib Wave Amplitude",
      "min": 0.5,
      "max": 5,
      "default": 2.2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "twistDeg",
      "label": "Shade Spiral Twist Angle",
      "min": 0,
      "max": 180,
      "default": 90,
      "step": 5,
      "unit": "deg",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "flowerLobes",
      "label": "Flower Lobes Count",
      "min": 3,
      "max": 8,
      "default": 4,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "flowerAmp",
      "label": "Flower Lobes Amplitude",
      "min": 4,
      "max": 30,
      "default": 14,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base_body",
      "label": "Fluted Cylinder Base and E27 Collar",
      "default": "#800020",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "shade_body",
      "label": "4-Lobe Spiral Flower Shade",
      "default": "#f8fafc",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "screws_body",
      "label": "M5.0 Anti-Slip Feet Screws",
      "default": "#e2e8f0",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "base_obj",
      "label": "Fluted Base",
      "name": "Fluted Base",
      "color": "#800020",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base_body",
          "label": "Fluted Cylinder Base and E27 Collar",
          "name": "Fluted Cylinder Base and E27 Collar",
          "groupId": 1,
          "colorKey": "base_body",
          "defaultColor": "#800020",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "shade_obj",
      "label": "Spiral Flower Shade",
      "name": "Spiral Flower Shade",
      "color": "#f8fafc",
      "assembled_z_offset": 0,
      "exploded_z_offset": 200,
      "parts": [
        {
          "id": "shade_body",
          "label": "4-Lobe Spiral Flower Shade",
          "name": "4-Lobe Spiral Flower Shade",
          "groupId": 0,
          "colorKey": "shade_body",
          "defaultColor": "#f8fafc",
          "assembled_z_offset": 0,
          "exploded_z_offset": 200,
          "export_stl": true
        }
      ]
    },
    {
      "id": "screws_obj",
      "label": "Feet and Screws",
      "name": "Feet and Screws",
      "color": "#e2e8f0",
      "assembled_z_offset": 0,
      "exploded_z_offset": -60,
      "parts": [
        {
          "id": "screws_body",
          "label": "M5.0 Anti-Slip Feet Screws",
          "name": "M5.0 Anti-Slip Feet Screws",
          "groupId": 2,
          "colorKey": "screws_body",
          "defaultColor": "#e2e8f0",
          "assembled_z_offset": 0,
          "exploded_z_offset": -60,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Lamp 021 Assembly"
    },
    {
      "id": "base",
      "label": "Download STL - Base Only (Module 01)"
    },
    {
      "id": "shade",
      "label": "Download STL - Shade Only (Module 06)"
    }
  ]
};
